<script>
	import { Table } from "./components";
	import { Confirm } from "./components/ui";

	let showConfirm = false;
	let counter = 0;
	let lastTouchtime = 0;
	const onClick = () => {
		if (Date.now() - lastTouchtime < 500) {
			console.log("here");
			counter++;
		}
		else {
			counter = 0;
		}
		lastTouchtime = Date.now();

		if (counter === 6) {
			showConfirm = true;
		}
	};

	const handleButtonClick = (button, index) => {
		showConfirm = false;

		if (button === "reload") {
			window.location.reload();
		}

		if (button === "reset") {
			window.localStorage.clear();
			window.location.reload();
		}
	}
</script>

<main on:touchmove={(event) => { event.preventDefault(); }} on:click={onClick}>
	<Table />
	{#if showConfirm}
		<Confirm text="What to do?" buttons={["reload", "reset", "cancel"]} onButton={handleButtonClick} />
	{/if}
	<div class="portrait">
		Nichts zu sehen im Hochformat.
	</div>
</main>

<style>
	:global(html) {
		overflow: hidden;
	}

	:global(body) {
		overflow: hidden;
		position: relative;
		background-image: url("../resources/img/background.jpg");
		background-size: 100%;
	}

	.portrait {
		display: none;

		position: absolute;

		align-items: center;
		justify-content: center;

		top: 0;
		left: 0;

		background-color: #ffffff;

		width: 100%;
		height: 100%;
	}

	@media (orientation: portrait) {
		.portrait {
			display: flex;
		}
	}

	main {
		text-align: center;
		height: 100%;
		margin: 0;
	}
</style>
